import { useEffect, useRef } from "react";
import { UserRound } from "lucide-react";

interface LocalPreviewProps {
  stream: MediaStream | null;
  isCameraOn: boolean;
  audioLevel: number;
}

export function LocalPreview({ stream, isCameraOn, audioLevel }: LocalPreviewProps) {
  const videoRef = useRef<HTMLVideoElement | null>(null);

  useEffect(() => {
    if (videoRef.current) {
      videoRef.current.srcObject = stream;
    }
  }, [stream]);

  return (
    <div className="local-preview">
      {isCameraOn && stream ? (
        <video ref={videoRef} autoPlay muted playsInline />
      ) : (
        <div className="local-placeholder">
          <UserRound size={28} />
        </div>
      )}
      <div className="level-meter">
        <span style={{ transform: `scaleX(${audioLevel})` }} />
      </div>
    </div>
  );
}
